import itCertificateCategoryApi from '@/api/common/it-certificate-category'

const data = {
  items: sessionStorage.getItem('itCertificateCategories')
    ? JSON.parse(sessionStorage.getItem('itCertificateCategories'))
    : []
}

export default {
  namespaced: true,
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Get all CompanySize.
     *
     * @param {*} param
     */
    all ({ commit, dispatch, state }, params) {
      if (state.items.length) return

      // params.with = ['itCertificates']

      return itCertificateCategoryApi.index({ with: ['itCertificates'] })
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('itCertificateCategories', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
    }
  }
}
